var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    _vm.className,
    'button flex justify-center',
    _vm.loader ? 'fade' : '',
    _vm.disabled ? 'disabled' : ''
  ],attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[(_vm.iconUrl)?_c('div',{staticClass:"beforeIcon"},[_c('img',{attrs:{"src":`/${_vm.iconUrl}.png`,"alt":""}})]):_vm._e(),(!_vm.loader)?_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_c('div',{staticClass:"loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }